import { useContext } from 'react';

import ShareIcon from '@/assets/all-icons/share-icon';
import ArtlistDataContext from '@/context/ArtlistDataContext';
import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import { handleShareFailure } from '@/utils/share.utils';

export default function ArtlistShareButton() {
  const { artlistData } = useContext(ArtlistDataContext);
  const { stateHandler } = useStateHandler();
  const t = useTranslations('common.profile.pages.artlist');
  const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  function shareArtlist() {
    const sharePayload = {
      title: artlistData.artlist_title,
      text: t('share.text', {
        username: artlistData.artlist_creator.user_username,
        title: artlistData.artlist_title,
      }),
      url: `https://suarte.art/artlist/${artlistData._id}`,
    };

    navigator
      .share(sharePayload)
      .catch((error) => handleShareFailure(error, stateHandler, 'Artlist share'));
  }

  if (!canShare) {
    return null;
  }

  return (
    <button
      type="button"
      className="artlist-page__share-button"
      onClick={shareArtlist}
      aria-label={t('options.menu.share_artlist')}
    >
      <ShareIcon aria-hidden="true" />
    </button>
  );
}
